export default __webpack_public_path__ + "static/media/Proxy-Delhaize-Grande-Haie-32.a095b978.jpg";